/**
 * Pagar a cobrança em aberto de uma troca/assinatura pendente: abre o checkout
 * da VIO em nova aba (preserva a sessão) ou, sem link ainda, leva às faturas.
 * Uma regra só para o modal de pagamento pendente e para a tela de planos.
 */
import { openInNewTab } from '@/lib/open-in-new-tab';

export const INVOICES_PATH = '/account?tab=billing';

export function payPendingCharge(
  checkoutUrl: string | null | undefined,
  goTo: (path: string) => void,
): void {
  if (checkoutUrl) {
    openInNewTab(checkoutUrl);
    return;
  }
  goTo(INVOICES_PATH);
}
